import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  children: React.ReactNode;
}

export const CannedQuestionListLayoutContainer: React.FC<Props> = ({
  children,
}) => {
  const [styles] = useStyles();
  const { isSmallLayout, isSmallTabletLayout } = useLayoutContext();

  return (
    <View style={styles.container}>
      {isSmallLayout ? (
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.smallContent}
        >
          {children}
        </ScrollView>
      ) : (
        <View
          style={
            isSmallTabletLayout ? styles.mediumContent : styles.largeContent
          }
        >
          {children}
        </View>
      )}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'flex-end',
    backgroundColor: theme.colors.white,
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 16,
    ...StyleSheet.absoluteFillObject,
  },
  largeContent: {
    width: 840,
  },
  mediumContent: {
    width: 416,
  },
  smallContent: {
    flex: 1,
    marginHorizontal: 16,
  },
}));
